(function () {
    'use strict';
    var controllerId = 'profiloOrarioAddEdit';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'profiliOre', 'profilo', '$translate', profiloOrarioSelectFn]);

    function profiloOrarioSelectFn($scope, $uibModalInstance, datacontext, profiliOre, profilo, $translate) {
        //Gestione date
        $scope.open = function ($event) {
            $scope.opened = !$scope.opened;
        };
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';

        $scope.profilo = profilo;        
        if ($scope.profilo.Id == 0)
            $scope.titolo = $translate.instant('AggiungiProfiloOrario');
        else
            $scope.titolo = $translate.instant('ModificaProfiloOrario') + ': ' + profilo.profiloOreDescrizione;

        $scope.fTesto = '';
        $scope.profili = profiliOre;        
        $scope.loading = false;        
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.edit = function () {
            if ($scope.profilo.DataFine)
                var dtFine = moment($scope.profilo.DataFine).format('DD/MM/YYYY');
            var result = {};
            editItem($scope.profilo).then(function (result) { // metto in result l'oggetto tornato dal server a seguito dell'aggiornamento (può essere nullo se non va a buon fine)
                if (result.Id && result.Id > 0)
                    $uibModalInstance.close(result);
            });
        };

        $scope.select = function (id) {
            $scope.profilo.profiloOreId = id;
            if ($scope.profilo.DataFine)
                var dtFine = moment($scope.profilo.DataFine).format('DD/MM/YYYY');

            var result = {};
            addItem($scope.profilo).then(function (result) {
                if (result.Id && result.Id > 0)
                    $uibModalInstance.close(result);
            });
        };

        // Modifica elemento
        function editItem(item) {
            return datacontext.profiloDipendenti_update(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) {
                    logError($translate.instant('Errore durante la creazione del dato'));            // In questo caso l'aggiunta non è andata a buon fine
                    return null;
                }
                return data;                                                    // altrimenti torna l'oggetto modificato
            });
        }

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.profiloDipendenti_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) {
                    logError($translate.instant('Errore durante la creazione del dato'));            // In questo caso l'aggiunta non è andata a buon fine
                    return null;
                }

                return data;                                                     // altrimenti torna il nuovo oggetto
            });
        }
    }
})();